'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemScreenReaderDescription = require('./components/ItemScreenReaderDescription.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemScreenReaderDescription).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-screen-reader-description/index.js
// module id = 839
// module chunks = 0